module.exports = __webpack_public_path__ + "static/media/us.f54becc3.svg";